module.exports = __webpack_public_path__ + "static/didier-bre.72caf87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/didier-bre.png
// module id = 502
// module chunks = 136956383308509